export const loadRecaptcha = () =>
  new Promise((resolve) => {
    const script = document.createElement('script');

    script.onload = () => resolve(true);

    script.setAttribute(
      'src',
      'https://www.google.com/recaptcha/api.js?render=6LdrvAspAAAAALZn5Cqp3qCMDvrIfvNY3A_Y8x__',
    );

    document.head.appendChild(script);
  });
